// Generated by purs version 0.11.7
"use strict";
var Prelude = require("../Prelude");
var MonadTrans = function (lift) {
    this.lift = lift;
};
var lift = function (dict) {
    return dict.lift;
};
module.exports = {
    lift: lift,
    MonadTrans: MonadTrans
};



//////////////////
// WEBPACK FOOTER
// ./output/Control.Monad.Trans.Class/index.js
// module id = 255
// module chunks = 0